////////LIBRARY/////////
import React, { useEffect, useState } from 'react'
import { map, isEmpty } from 'lodash'
import styled from 'styled-components'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { bindActionCreators } from 'redux'
///////COMPONENTS///////
import { languagesActionCreators } from '../../store/actions'

/////////STYLED/////////
const FlagImgWrapper = styled.img`
	max-width: 26px;
	height: 17px;
	cursor: pointer;
	box-sizing: content-box;
	border: ${(props) => (props.selectedLanguage ? `1px solid ${props.theme.colors.primary}` : 'none')};
	border-radius: 3px;
	margin: 0px 10px;
`
/////////STYLED/////////

const SwitchLanguage = ({ scope, ...rest }) => {
	const { languagesList, selectedLanguage } = useSelector(
		(state) => ({
			languagesList: state.languages.items,
			selectedLanguage: state.languages.selectedLanguage,
		}),
		shallowEqual
	)

	const actionsLanguages = bindActionCreators(languagesActionCreators, useDispatch())

	const [currentLanguagesList, setCurrentLanguagesList] = useState([])

	///////////////////////////////// HANDLE ///////////////////////////////////////
	/**
	 * call to change user languages
	 * @param   {string}        idLanguage
	 * @param   {string}        scope for language ( e.g 'public' || 'private' )
	 */
	const handleLanguage = (idLanguage, scope) => {
		if (scope === 'private') {
			actionsLanguages.getTranslationByLanguages(idLanguage)
		} else {
			actionsLanguages.getTranslationPublicPage(idLanguage)
		}
	} // end function

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		if (!isEmpty(languagesList)) {
			let ord = languagesList.sort((a, b) => a.labelEnglish > b.labelEnglish)
			setCurrentLanguagesList(ord)
		}
	}, [languagesList])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return map(currentLanguagesList, (elem, id) => {
		return (
			<FlagImgWrapper
				src={`/${elem?.picturePath}`}
				selectedLanguage={selectedLanguage === elem?.id}
				onClick={() => handleLanguage(elem?.id, 'public')}
				scope="public"
			/>
			/* 	<Base64Images
					key={ id }
					base64={ elem.picture_path }
					width='26'
					height='17'
					idElem={ elem.id }
					scope={ scope }
					click={ handleLanguage }
				/> */
		)
	})
}

SwitchLanguage.propTypes = {}

SwitchLanguage.defaultPropTypes = {}

export default SwitchLanguage
